import { Component, Prop, Watch, Vue } from '~/utility/pu-class-decorator'
import type { DatepickerAvailabilityMachineInterpreter } from './machine'
import { DatepickerAvailabilityResultsDay } from './types'
import { getDatepickerAvailabilityMachine } from './inversify.config'

@Component
export class DatepickerAvailabilityBaseComponent extends Vue {
  datepickerAvailabilityMachine: DatepickerAvailabilityMachineInterpreter
  datepickerAvailability: DatepickerAvailabilityResultsDay[] = []

  @Prop()
  campsiteSlug: string

  @Prop({ default: () => [] })
  selectedCategoryIds: string[]

  @Prop()
  pitchtypeId: string

  get datepickerAvailabilityCampsiteSlug() {
    return this.campsiteSlug
  }

  get datepickerAvailabilitySelectedCategoryIds() {
    return this.selectedCategoryIds
  }

  availabilityLoaded = false

  @Watch('pitchtypeId')
  updateAvailability() {
    this.initAvailability(this.$route.params.lang || 'en-gb').catch(() => {
      // Datepicker availability is non-critical — degrade gracefully
    })
  }

  protected getDatepickerAvailabilityFetchingParams() {
    if (!this.datepickerAvailabilityCampsiteSlug) {
      throw new Error(`No campsite slug available for ${this.$options.name}`)
    }

    const params = {
      slug: this.datepickerAvailabilityCampsiteSlug,
      categories: this.datepickerAvailabilitySelectedCategoryIds,
      pitchtypeId: '',
    }

    if (this.pitchtypeId) {
      params.pitchtypeId = this.pitchtypeId
    }
    return params
  }

  initAvailability(langCode: string) {
    const datepickerAvailabilityMachine = this.getAvailabilityMachine(langCode)
    return new Promise<void>((resolve, reject) => {
      datepickerAvailabilityMachine
        .onTransition((state) => {
          if (state.changed && state.matches('availabilityLoaded')) {
            this.availabilityLoaded = true
            this.datepickerAvailability = state.context.availability || []
            resolve()
          }

          if (state.matches('error')) {
            reject(
              new Error(
                'DatepickerAvailabilityBaseComponent initAvailability datepickerAvailabilityMachine error',
              ),
            )
          }
        })
        .start()
        .send('FETCH', this.getDatepickerAvailabilityFetchingParams())
    })
  }

  getAvailabilityMachine(langCode: string) {
    return getDatepickerAvailabilityMachine(langCode)
  }
}
